import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { LookInside } from './components/LookInside';
import { BonusesSection } from './components/BonusesSection';
import { NotAnEbook } from './components/NotAnEbook';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { DifferenceSection } from './components/DifferenceSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { MetaPixel } from './components/MetaPixel';
interface AppProps {
  showPurchaseToasts?: boolean;
}
export function App({
  showPurchaseToasts = true
}: AppProps) {
  return <div lang="en" className="w-full bg-slate-950 font-sans antialiased" data-id="element-0" data-mp="23ti7s3go4sjo">
      <Hero data-id="element-1" data-mp="3ijftvw9y1qd1" />
      <main data-id="element-2" data-mp="3ihv048vgebg8">
        <ProblemSection data-id="element-3" data-mp="3ii4ppvcl6gle" />
        <SystemSection data-id="element-4" data-mp="3ml12h5fg3ihf" />
        <WhatsIncluded data-id="element-5" data-mp="3mk85uxa7a9d0" />
        <LookInside data-id="element-6" data-mp="3mjpyb4i388ps" />
        <BonusesSection data-id="element-7" data-mp="3rc9f0ac2njyt" />
        <NotAnEbook data-id="element-8" data-mp="3rbrcivytg9ig" />
        <OfferSection data-id="element-9" data-mp="3rdkhm6ts6loc" />
        <GuaranteeSection data-id="element-10" data-mp="3rd191gq0t9mz" />
        <DifferenceSection data-id="element-11" data-mp="5yi8qe3h5da" />
        <FaqSection data-id="element-12" data-mp="6817u0q2c9h" />
        <FinalCta data-id="element-13" data-mp="4n7g6m8exco" />
      </main>
      <Footer data-id="element-14" data-mp="7sulgbavp5r" />
      {showPurchaseToasts && <PurchaseToast data-id="element-15" data-mp="2zlv66six0xu0" />}
      <MetaPixel data-id="element-16" data-mp="2zmenc70qri6z" />
    </div>;
}